import React from 'react';
import CustomSweetAlert from '../../../CustomSweetAlert';

export type DialogType = 'warning' | 'success' | 'error' | 'info';

export interface ConfirmationDialogProps {
  open: boolean;
  title: string;
  message: string;
  type?: DialogType;
  t: (key: string) => string;
  onClose?: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
}

const defaultProps = {
  type: 'warning' as const,
  confirmText: 'appointment.dialog.btn.ok',
  cancelText: 'appointment.dialog.btn.no'
};

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ 
  open, 
  onClose, 
  title, 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = defaultProps.confirmText, 
  cancelText = defaultProps.cancelText, 
  type = defaultProps.type,
  t
}) => {
  if (!open) return null;
  
  return (
    <CustomSweetAlert
      type={type}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmBtnCssClass="primary"
      cancelBtnCssClass="danger"
      title={title}
      cancelBtnText={cancelText}
      confirmBtnText={confirmText}
      showCancel={!!onCancel}
      message={<p>{message}</p>}
    />
  );
};

export default ConfirmationDialog; 